import React, {createContext, ReactNode, useContext, useEffect} from "react";
import {ColorsType, DynamicColorsType} from "../color_models";
import {Colors as StaticColors} from "../colors-base";
import {updateDynamicColors} from "../colors";

interface ColorContextType {
  colors: ColorsType;
}

const ColorContext = createContext<ColorContextType>({
  colors: StaticColors,
});

export const useColors = () => {
  const context = useContext(ColorContext);
  return context.colors;
};

interface ColorProviderProps {
  children: ReactNode;
  dynamicColors?: DynamicColorsType;
}

export const ColorProvider: React.FC<ColorProviderProps> = ({children, dynamicColors}) => {
  const mergedColors: ColorsType = {
    ...StaticColors,
    ...(dynamicColors && {
      primary: {...StaticColors.primary, ...dynamicColors.primary},
      secondary: {...StaticColors.secondary, ...dynamicColors.secondary},
      tertiary: {...StaticColors.tertiary, ...dynamicColors.tertiary},
    }),
  };
  useEffect(() => {
    if (dynamicColors) {
      updateDynamicColors(dynamicColors);
    }
  }, [dynamicColors]);

  return <ColorContext.Provider value={{colors: mergedColors}}>{children}</ColorContext.Provider>;
};
